import { createFileRoute } from "@tanstack/react-router";
import { MojFaqHub } from "@/components/MojFaqHub";
import { canonicalAndHreflangEn, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";
const TITLE = "MoJ Certified Translator — FAQ & 300-Keyword Hub | NYC Thailand";
const DESC = "300 keywords across 8 clusters for Thai Ministry-of-Justice certified translation: litigation, contracts. Start with a free review before you file anything.";

export const Route = createFileRoute("/en/moj-translator/faq")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, "/en/moj-translator/faq", "en")},
      { name: "description", content: ctaDesc(DESC, "/en/moj-translator/faq", "en")},
      { property: "og:title", content: ctaTitle(TITLE, "/en/moj-translator/faq", "en")},
      { property: "og:description", content: ctaDesc(DESC, "/en/moj-translator/faq", "en")},
      { property: "og:url", content: `${SITE}/en/moj-translator/faq` },
      { property: "og:locale", content: "en_US" },
    ],
    links: canonicalAndHreflangEn("/en/moj-translator/faq", "/moj-translator/faq"),
  }),
  component: () => <MojFaqHub lang="en" />,
});
